export const branding = {
  brandName: 'Volitiq',
  productTagline: 'Motor movement tracking and analysis',
  contactEmail: 'info@volitiq.com',
  domain: 'volitiq.com',
  parentLabUrl: undefined as string | undefined,
  parentLabName: undefined as string | undefined,
} as const;

export type Branding = typeof branding;
